import { createSelector } from 'reselect';
import { getActiveSpaceId } from 'spaces/store/selectors';

const roleIds = (state) => state.roles.ids;

export const getRolesById = (state) => state.entities.roles || {};

export const getRolesIsLoading = (state) => state.roles.isLoading;

export const getActiveRoleId = (state) => state.roles.activeRoleId;

export const getRoleIdsBySpaceId = (state) => state.roles.rolesBySpaceId;

export const getActiveSpaceRoleIds = createSelector(
  [getActiveSpaceId, getRoleIdsBySpaceId],
  (spaceId, ids) => (ids[spaceId] ? ids[spaceId] : []),
);

export const getActiveSpaceRoles = createSelector(
  [getActiveSpaceRoleIds, getRolesById],
  (ids, rolesById) => (ids.length > 0 ? ids.map((id) => rolesById[id]) : []),
);


export const getActiveRole = createSelector(
  [getRolesById, getActiveRoleId],
  (roles, id) => roles[id],
);

export const getAllRoles = createSelector(
  [getRolesById, roleIds],
  (roles, ids) => ids.map((id) => roles[id])
    .sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase())),
);

export const getRoleSelectOptions = createSelector(
  [getRolesById, roleIds],
  (roles, ids) => ids
    .map((id) => ({
      value: id,
      label: roles[id].name,
    })),
);
